// extracted by mini-css-extract-plugin
export var csatScore = "_j8-5";
export var header = "_j8-1";
export var panelWrapper = "_j8-2";
export var postPreview = "_j8-3";
export var rightContent = "_j8-0";
export var wrappingText = "_j8-4";